import React, { PropsWithChildren } from "react";

import { Box, Flex } from "@chakra-ui/react";

import SidebarMenu from "@/components/SidebarMenu";
import { LayoutMode, layoutModes } from "@/constants/layoutModes";

function SidebarMenuLayout<T extends string>({
  mode = layoutModes.default,
  selectedItem,
  children,
}: PropsWithChildren<{ mode?: LayoutMode; selectedItem?: T }>) {
  return (
    <Flex h="full" w="full">
      <SidebarMenu<T> selectedItem={selectedItem} {...mode.sidebarMenu} />
      <Box flex={1}>{children}</Box>
    </Flex>
  );
}

export default SidebarMenuLayout;
